import { Text, View } from '@react-pdf/renderer';
import { Calendar, Clock } from 'lucide-react';
import { type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';
import { LucidePdfIcon, PDF_ICON_SIZE } from '../PdfIcon';

interface DateTimeBarProps {
  dateLabel: string;
  dateValue: string;
  timeLabel: string;
  timeValue: string;
}

export const DateTimeBar = ({
  dateLabel,
  dateValue,
  timeLabel,
  timeValue,
}: DateTimeBarProps): ReactElement => (
  <View style={PDF_STYLES.dateTimeWrap}>
    <View style={PDF_STYLES.dateTimeBar}>
      <View style={PDF_STYLES.dateTimeColumn}>
        <LucidePdfIcon icon={Calendar} size={PDF_ICON_SIZE.lg} />
        <View style={PDF_STYLES.dateTimeText}>
          <Text style={PDF_STYLES.dateTimeLabel}>{dateLabel}</Text>
          <Text style={PDF_STYLES.dateTimeValue}>{dateValue}</Text>
        </View>
      </View>
      <View style={PDF_STYLES.dateTimeColumn}>
        <LucidePdfIcon icon={Clock} size={PDF_ICON_SIZE.lg} />
        <View style={PDF_STYLES.dateTimeText}>
          <Text style={PDF_STYLES.dateTimeLabel}>{timeLabel}</Text>
          <Text style={PDF_STYLES.dateTimeValue}>{timeValue}</Text>
        </View>
      </View>
    </View>
  </View>
);
